<template>
    <div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" :confKey="confKey" :configAuto="true" :queryOnLoad="true" :onConfigReady="onQueryConfigReady" :queryHandler="queryHandler"></swb-query-sort-area>
        </div>
        <!--<div class="tab-container small base">-->
        <!--<div class="tabs-nav">-->
        <!--<ul class="head">-->
        <!--<li :class="{'current': status.value == checkStateValue}" class="head-item" v-for="status in tableState" @click="handleTabClick(status.value)">-->
        <!--<span>{{status.text}}</span>-->
        <!--</li>-->
        <!--</ul>-->
        <!--</div>-->
        <!--</div>-->
        <div name="btn-bar" class="simple-row">
            <div class="right">
                <div class="swb-btn swb-btn-small swb-btn-primary" v-if="checkActionPerm('task_export')" @click="taskExport()">执行导出任务</div>
                <div class="swb-btn swb-btn-small swb-btn-primary" v-if="checkActionPerm('view_task_export')" @click="viewTaskExport()">查看结果文件</div>
            </div>
        </div>
        <swb-result-table name="result_table" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName"
                          :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="tableHeight"
                          :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
    </div>
</template>

<script>
    import {Utils, $} from '../../app.base'
    import {Vue, MsgBox, Routes, DomSizeWatcher} from '../../app.vues'
    import {getDefaultPageSizes, getDefaultDownloadPageSize} from '../../app.conf'
    import {showGrpDownloadDlg} from '../ctrl/dialog'
    import {loadDevcCatListList} from '../retailer/asset-comn'
    import {checkUserActionPerm, getMerchtAssetNatureMap} from '../index'
    //
    import assetBizdtlApi from '../../api/assetBizdtl'
    //
    import SwbResultColConf from '../query/ResultColConf.vue';
    import SwbResultTable from '../query/ResultTable.vue';

    Vue.regist(SwbResultColConf);
    Vue.regist(SwbResultTable);

    import SwbQuerySortArea from '../query/QuerySortArea';

    Vue.regist(SwbQuerySortArea);

    import SwbShopDeviceTransVoucherView from '../transVoucher/ShopDeviceTransVoucherView'
    import {showTaskExportDlg, showTaskExportListDlg} from "../devc/selectDlg";

    Vue.regist(SwbShopDeviceTransVoucherView);

    export default {
        name: 'swb-asset-trans-bizdtl-list-main',
        path: '/asset/trans/bizdtl/list/main',
        avlActions: '',
        avlScopes: 'retailer',
        authen: false,
        desc: '资产调拨清单',
        data: function () {
            return {
                confKey: 'asset-trans-bizdtl-list',
                queryOnLoad: true,
                tableHeight: 300,
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: true, //是否多选（默认：false）
                multiPageSelect: true, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: 'id', //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）
                btnColName: '',//操作列名称（如果不设置就不显示操作列）
                //
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 200,//操作列宽度（默认：100）
                //
                btnColFixed: true, //操作列是否固定
                resultColConf: {//不想要列配置设置 = null即可
                    metaColList: []
                },
                //
                pageSize: getDefaultPageSizes().first(),
                pageNumber: 1,
                //排序、搜索
                queryConfig: {},
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                //
                tableState: [],
                checkStateValue: 0,
                exportParmas: {},
                //
                isSkipFlag: false,
                transVoucherNo: null,
                innerCode: null
            }
        },
        created: function () {
            this.tableState = [{'text': '单品式', 'value': 0}, {'text': '批量式', 'value': 1}];
            //
            this.transVoucherNo = this.$route.query.transVoucherNo || null;
            this.innerCode = this.$route.query.innerCode || null;
            if (!Utils.isNoB(this.transVoucherNo)) {
                this.isSkipFlag = true;
            }
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass('overflow-hidden');
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name = "result_table"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.tableHeight = height;
            });
            //domSizeWatcher.setHrEls();  .tab-container,
            domSizeWatcher.setVtEls(thisEl.find('[name="query-sort-block"], [name="btn-bar"]'));
            domSizeWatcher.start(500);
            //
            this.initResultTable();
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if (domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            checkActionPerm: function (action, targetPostId) {
                return checkUserActionPerm(Vue.$getClassInfo(this).path, action, targetPostId);
            },
            handleTabClick(val) {
                this.checkStateValue = val;
                this.getAssetList();
            },
            onQueryConfigReady: function () {
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                // 资产属性
                getMerchtAssetNatureMap((merchtAssetNatureList) => {
                    if (merchtAssetNatureList.length > 0) {
                        let dataList = [{'value': null, 'label': '- 全部 -'}];
                        merchtAssetNatureList.forEach(function (item) {
                            let dataInfo = {};
                            dataInfo.value = item.value;
                            dataInfo.label = item.text;
                            dataList.push(dataInfo);
                        });
                        let updateField = {
                            assetNature: {
                                value: null,
                                dataList: dataList
                            }
                        };
                        if (!this.isSkipFlag) {
                            updateField.bizPeriod = {
                                value: new Date().format('yyyyMM')
                            };
                        } else {
                            updateField.assetNature.value = null;
                        }
                        query_model_ctrl.updateFields(updateField);
                    }
                });
                // 调拨单号
                let updateVoucherNoField = {
                    voucherNo: {
                        value: this.transVoucherNo,
                    },
                };
                query_model_ctrl.updateFields(updateVoucherNoField);
                // 调出资产编号
                let updateSrcInnerCodeField = {
                    srcInnerCode: {
                        value: this.innerCode,
                    },
                };
                query_model_ctrl.updateFields(updateSrcInnerCodeField);
                // 资产分类
                loadDevcCatListList(function (devcCatList) {
                    self.updateQueryModelField('innerDevcCatId', devcCatList);
                });
            },
            updateQueryModelField: function (itemCode, dataList = []) {
                if (itemCode != null) {
                    let query_model_ctrl = this.$refs['query_model_ctrl'];
                    let data = {dataList: dataList};
                    let fieldInfo = {};
                    fieldInfo[itemCode] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
            },
            initResultTable() {
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[查询排序对象]到结果表格（结果表格可以实时利用最新的 列配置 和 排序信息，同时结果表格列宽也会反向同步到其中的[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'netWorth2': function (row, colName, colValue, rowIndex) {
                        if (!Utils.isNoB(row.netWorth) && !Utils.isNoB(row.quantity)) {
                            return '<span>' + (row.netWorth * row.quantity).toFixed(2) + '</span>';
                        } else {
                            return '<span>0.00</span>';
                        }
                    },
                    'auditNo': function (row, colName, colValue, rowIndex, btnName) {
                        if (!Utils.isNoB(row.auditNo)) {
                            return '<span><a class="table-cell-link" >' + row.auditNo + '</a></span>';
                        } else {
                            return '<span>' + row.auditNo + '</span> ';
                        }
                    },
                    'actions': function (row, colName, colValue, rowIndex) {
                    }
                }, /* 单元格按钮点击处理函数 */{
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                    'auditNo': function (row, colName, colValue, rowIndex, btnName) {
                        // row.voucherNo
                        if (!Utils.isNoB(row.auditNo)) {
                            Vue.$showDialog({
                                title: '资产调拨-详情',
                                width: -200,
                                height: -100,
                                okVisible: false,
                                showCloseBtn: true,
                                cancelText: '关闭',
                                template: '<swb-trans-voucher-view :parentSelf="parentSelf" :no="no"></swb-trans-voucher-view>',
                                data: {
                                    parentSelf: self,
                                    no: row.voucherNo
                                }
                            });
                        }
                    },
                    'actions': function (row, colName, colValue, rowIndex, btnName, evnt) {
                    }
                });
            },
            renderTable(rows, pagination) {
                let resultTable = this.$refs.result_table;
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };
                resultTable.render(tableData);
            },
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if (!this.multiSelect) {
                    console.log('----- 双击数据行 ----');
                    console.log(row);
                }
            },
            getTableSelection() {
                let resultTable = this.$refs.result_table;
                return resultTable.getSelection();
            },
            queryHandler(queryModel) {
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.lastPageNumber = null;
                //
                this.getAssetList();
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log('分页 => 第【' + pageNumber + '】页，大小：' + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                this.lastPageNumber = null;
                //
                this.getAssetList();
            },
            getAssetList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
//                if(self.checkStateValue == 1) {
//                    filterItems.assetType = 1;
//                } else {
//                    filterItems.assetType = 0;
//                }
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                self.exportParmas = filterItems;
                //
                let theLoad = MsgBox.loading();
                assetBizdtlApi.getAssetTransBizdtlByFilter(postData, function (result) {
                    theLoad.hide();
                    if (result.type === 'info') {
                        let data = result.data;
                        let shopDeviceSubNoList = data.rows || [];
                        //
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pagesize = pagination.pageSize;
                        self.renderTable(shopDeviceSubNoList, pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            taskExport() {
                if (this.totalCount <= 0) {
                    MsgBox.warning('没有需要导出的数据');
                    return;
                }
                let resultTable = this.$refs.result_table;
                let tableData = resultTable.getTableData(true);
                delete tableData.rows;//减少数据传输量
                tableData.data = this.getPostData();
                tableData.pageSize = 1000;
                tableData.fileRows = 500000;
                showTaskExportDlg('zcdb.list.export', tableData);
            },
            viewTaskExport() {
                showTaskExportListDlg('zcdb.list.export');
            },
            getPostData() {
                let queryModel = this.queryModel;
                let filterItems = Utils.merge({}, this.exportParmas);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                let multipleSelection = this.getTableSelection();
                if (multipleSelection.length > 0) {
                    let ids = [];
                    multipleSelection.forEach(function (el) {
                        ids.push(el.id);
                    });
                    filterItems.ids = ids;
                }
                filterItems.export = true;
                //
                let postData = {};
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                return postData;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/bizDtl/AssetTransDtlListMain.vue